"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var tailwind_1 = __importDefault(require("./tailwind"));

exports.default = tailwind_1.default;